export let searchurl = ()=> {            
    let pairs = location.search.slice(1).split('&');
    
    let result = {};
    pairs.forEach(function(pair) {
        pair = pair.split('=');
        result[pair[0]] = decodeURIComponent(pair[1] || '');
    });

    return JSON.parse(JSON.stringify(result));
}

// import {searchurl} from '@/js/components/searchurl.js'